import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FormatCompensationPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatCompensation',
})
export class FormatCompensationPipe implements PipeTransform {
  /**
   * Takes a job and displays the compensation in a human readable format Based
   * on the following fields:

   */

  formatPrice = function(value) {
    let str = String(value).replace(/[^0-9.]/g, ''),
      d = Number(str) || 0,
      b = d < 0 ? '-$' : '$';

    return (
      '$' +
      d
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        .replace(/\.00$/, '')
    );
  };

  transform(job: any, ...args) {
    let s = '';
    // PAY PER MILE
    if (job.paymentType === 'paypermile') {
      // Range Pay Per Mile (e.g. $0.80 - $1.20 per mile)
      if (job.payRateRange) {
        s += this.formatPrice(job.payRateMin);
        s += ' - ';
        s += this.formatPrice(job.payRateMax);
        s += ' per mile';
        return s;
      }
      // Fixed Per Per Mile (e.g. Up to $1.23 per mile)
      else {
        s += job.payRateUpTo ? 'Up to ' : '';
        s += this.formatPrice(job.payRate);
        s += ' per mile';
        return s;
      }
    }
    // PAY PER HOUR
    else if (job.paymentType === 'payperhour') {
      // Range Pay Per Hour (e.g. $15.50 - $18.50 per hour)
      if (job.payRateRange) {
        s += this.formatPrice(job.payRateMin);
        s += ' - ';
        s += this.formatPrice(job.payRateMax);
        s += ' per hour';
        return s;
      }
      // Fixed Per Per Mile (e.g. Up to $1.23 per mile)
      else {
        s += job.payRateUpTo ? 'Up to ' : '';
        s += this.formatPrice(job.payRate);
        s += ' per hour';
        return s;
      }
    } else if (job.paymentType === 'percentLoad') {
      return (job.payRate || '').replace('%', '') + '% of line haul';
    } else if (job.paymentType === 'salary') {
      return 'Salary';
    } else if (job.paymentType === 'varies') {
      return 'Varies';
    } else if (job.paymentType === 'calltodiscuss') {
      return 'Call to Discuss';
    } else {
      return 'Call to Discuss';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-compensation/format-compensation.ts